
    import './styles.scoped.css';
    export default {
  "flash-refresh": "awsui_flash-refresh_1q84n_1gutj_94",
  "enter": "awsui_enter_1q84n_1gutj_94",
  "flash-body": "awsui_flash-body_1q84n_1gutj_109",
  "flash-message": "awsui_flash-message_1q84n_1gutj_109",
  "flash-header": "awsui_flash-header_1q84n_1gutj_109",
  "flash-content": "awsui_flash-content_1q84n_1gutj_110",
  "action-button-wrapper": "awsui_action-button-wrapper_1q84n_1gutj_111",
  "dismiss-button-wrapper": "awsui_dismiss-button-wrapper_1q84n_1gutj_112",
  "flash-icon": "awsui_flash-icon_1q84n_1gutj_135",
  "entering": "awsui_entering_1q84n_1gutj_148",
  "entered": "awsui_entered_1q84n_1gutj_169",
  "exiting": "awsui_exiting_1q84n_1gutj_274",
  "flashbar": "awsui_flashbar_1q84n_1gutj_296",
  "flash": "awsui_flash_1q84n_1gutj_94",
  "flash-list": "awsui_flash-list_1q84n_1gutj_351",
  "flash-focus-container": "awsui_flash-focus-container_1q84n_1gutj_387",
  "flash-text": "awsui_flash-text_1q84n_1gutj_393",
  "dismiss-button": "awsui_dismiss-button_1q84n_1gutj_112",
  "breakpoint-default": "awsui_breakpoint-default_1q84n_1gutj_434",
  "flash-list-item": "awsui_flash-list-item_1q84n_1gutj_434",
  "action-button": "awsui_action-button_1q84n_1gutj_111",
  "flash-type-success": "awsui_flash-type-success_1q84n_1gutj_447",
  "flash-type-error": "awsui_flash-type-error_1q84n_1gutj_451",
  "flash-type-warning": "awsui_flash-type-warning_1q84n_1gutj_455",
  "flash-type-info": "awsui_flash-type-info_1q84n_1gutj_459",
  "stack": "awsui_stack_1q84n_1gutj_463",
  "expanded": "awsui_expanded_1q84n_1gutj_468",
  "collapsed": "awsui_collapsed_1q84n_1gutj_482",
  "item": "awsui_item_1q84n_1gutj_488",
  "visual-refresh": "awsui_visual-refresh_1q84n_1gutj_498",
  "flash-items": "awsui_flash-items_1q84n_1gutj_504",
  "toggle": "awsui_toggle_1q84n_1gutj_511",
  "icon": "awsui_icon_1q84n_1gutj_574"
};
  